(function() {
  var capturedColors = {};
  var capturedImageUrl = '';

  // Captura colores al hacer clic en swatches
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('[class*="tda-customizer-customization-option-value"]');
    if (!swatch) return;
    const section = swatch.closest('.tda-customizer-customization-option');
    if (!section) return;
    const titleEl = section.querySelector('.tda-customizer-customization-option-title');
    if (!titleEl) return;
    const title = titleEl.innerText.trim().toLowerCase();
    const innerSpan = swatch.querySelector('.tda-tooltiptext span');
    const colorName = innerSpan ? innerSpan.innerText.trim() : '';
    if (!colorName) return;
    if (title.includes('exterior')) capturedColors['Color Exterior'] = colorName;
    else if (title.includes('interior')) capturedColors['Color Interior'] = colorName;
    console.log('A3D color guardado:', capturedColors);
  }, true);

  // Captura la URL de la imagen cuando Angle 3D la sube
  const origFetch = window.fetch;
  window.fetch = function(url, options) {
    const result = origFetch.apply(this, arguments);
    if (typeof url === 'string' && url.includes('file-upload')) {
      result.then(function(r) {
        r.clone().json().then(function(data) {
          if (data && data.public_url) {
            capturedImageUrl = data.public_url;
            console.log('A3D imagen capturada:', capturedImageUrl);
          }
        }).catch(function(){});
      });
    }
    return result;
  };

  // También monitorea XHR para la imagen
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(body) {
    if (this._url && this._url.includes('file-upload')) {
      this.addEventListener('load', function() {
        try {
          var data = JSON.parse(this.responseText);
          if (data && data.public_url) {
            capturedImageUrl = data.public_url;
            console.log('A3D imagen XHR capturada:', capturedImageUrl);
          }
        } catch(e) {}
      });
    }
    return origSend.call(this, body);
  };

  function injectViaChangeJS(lineItemKey) {
    var props = Object.assign({}, capturedColors);
    if (capturedImageUrl) props['Logo'] = capturedImageUrl;
    if (Object.keys(props).length === 0) return;
    capturedColors = {};
    capturedImageUrl = '';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, properties: props })
    }).then(function() {
      console.log('A3D propiedades inyectadas:', props);
    }).catch(function(e) {
      console.log('A3D change.js error:', e);
    });
  }

  // Intercepta fetch al carrito
  window.fetch = (function(origFetch) {
    return function(url, options) {
      if (typeof url === 'string' && url.includes('/cart/add')) {
        return origFetch.apply(this, arguments).then(function(response) {
          response.clone().json().then(function(data) {
            const key = data.key || (data.items && data.items[0] && data.items[0].key);
            if (key) injectViaChangeJS(key);
          }).catch(function(){});
          return response;
        });
      }
      if (typeof url === 'string' && url.includes('file-upload')) {
        var result = origFetch.apply(this, arguments);
        result.then(function(r) {
          r.clone().json().then(function(data) {
            if (data && data.public_url) {
              capturedImageUrl = data.public_url;
              console.log('A3D imagen capturada:', capturedImageUrl);
            }
          }).catch(function(){});
        });
        return result;
      }
      return origFetch.apply(this, arguments);
    };
  })(window.fetch);

  // Intercepta XHR al carrito
  XMLHttpRequest.prototype.send = (function(origSend) {
    return function(body) {
      if (this._url && this._url.includes('/cart/add')) {
        this.addEventListener('load', function() {
          try {
            var data = JSON.parse(this.responseText);
            var key = data.key || (data.items && data.items[0] && data.items[0].key);
            if (key) injectViaChangeJS(key);
          } catch(e) {
            fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
              if (cart.items && cart.items.length > 0) injectViaChangeJS(cart.items[0].key);
            });
          }
        });
      }
      if (this._url && this._url.includes('file-upload')) {
        this.addEventListener('load', function() {
          try {
            var data = JSON.parse(this.responseText);
            if (data && data.public_url) {
              capturedImageUrl = data.public_url;
              console.log('A3D imagen XHR capturada:', capturedImageUrl);
            }
          } catch(e) {}
        });
      }
      return origSend.call(this, body);
    };
  })(origSend);

})();
